// stores/session.js
import { defineStore } from 'pinia'
import http from '../api/http'
import socket from '../services/socket'
import router from '../router'

export const useSessionStore = defineStore('session', {
  state: () => ({
    user: null
  }),
  actions: {
    setUser(user) {
      this.user = user
      if (user && !socket.connected) socket.connect()
    },
    async checkAuth() {
      try {
        const res = await http.get('/api/auth/check')
        this.user = res.data.user
        if (this.user && !socket.connected) socket.connect()
        return true
      } catch (err) {
        this.destroy()
        return false
      }
    },
    destroy() {
      this.user = null
      if (socket.connected) socket.disconnect()
    },
    async logout() {
      try {
        await http.post('/api/auth/logout')
      } catch (err) {
        console.error('Error al cerrar sesión:', err)
      } finally {
        this.destroy()
        router.push('/login')
      }
    }
  }
})
